/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, HostListener, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { ConversionService } from './services/conversion.service';
import { Subject } from 'rxjs';
import { AuthService } from './services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  private userActivityTimeout;
  userInactive: Subject<any> = new Subject();

  private INACTIVITY_TIME = 60 * 60 * 1000; // minutes × 60 seconds × 1000 milliseconds
  
  constructor(
    private authSrvc: AuthService,
    private analytics: AnalyticsService, 
    private router: Router,
    private seoService: SeoService,
    private conversionSrvc: ConversionService,
  ) {}

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    this.conversionSrvc.getConversion_Latest();

    this.resetTimer(); // start the inactivity timer

    this.userInactive.subscribe(() => {
      this.authSrvc.logout();
      localStorage.clear();
      this.router.navigate(['auth/login']);
      alert("Session expired due to inactivity. Please log in again to continue.");
    });
  }

  // Listen to various user events to detect activity
  @HostListener('window:mousemove')
  @HostListener('window:keydown')
  @HostListener('window:scroll')
  @HostListener('window:click')
  @HostListener('window:touchstart')
  refreshUserState() {
    this.resetTimer();
  }

  private resetTimer() {
    clearTimeout(this.userActivityTimeout);
    this.userActivityTimeout = setTimeout(() => {
      this.userInactive.next(undefined);
    }, this.INACTIVITY_TIME);
  }
}
